import BaseStudy from "./BaseStudy";
import eventBus from "../../utils/EventBus";

class Study extends BaseStudy {

    async getData(data = null) {
        const [admittedStatus = undefined] = (data?.admittedStatus ?? []);
        const _data = {
            patient_ids: data?.patientID,
            first_name: data?.patientFirstName,
            last_name: data?.patientLastName,
            sex: data?.sex,
            modalities: data?.modalities,
            report_statuses: data?.reportStatus,
            report_text: data?.report_text,
            comments: data?.comments,
            referring_physicians_name: data?.referringPhysiciansName,
            performing_physicians_name: data?.performingPhysiciansName,
            operators_name: data?.operatorsName,
            inpatient_status: data?.inPatient,
            date_from: data?.datepickerFrom,
            date_to: data?.datepickerTo,
            start: data?.start,
            limit: data?.limit,
            my_reports: data?.myReports ? "1" : undefined,
            similarity: data?.like ? "like" : undefined,
            grouping: data?.grouping ?? false,
            response_type: data?.response_type ?? undefined,
            status_admitted: admittedStatus,
	        include_actions: '6,7,11,22,63'
        };
        eventBus.dispatchEvent("NavbarCheckFiltersAndStudyFilter", _data)
        return this.fullFetch("study","get", {data:_data, responseType: data?.response_type === "excel" ? "blob" : undefined});
    }


    getResource() {
        return 'study';
    }
}


export default Study;